// extracted by mini-css-extract-plugin
export default {"container":"yV3V_N8OSLTgz8EMaYqg","titleBlock":"MrxaFiEeVGTyEfAR4NBV","title":"xDxCuKyPhDMKja8NxfED","description":"UwYKe3rb8ilhVA0dL3y8"};